/**
 * Created by cd01 on 2017/12/23.
 */

{
    angular.module('interfaceModule')
        .controller('RechargeRecordController',RechargeRecordController);
    RechargeRecordController.$inject = ['$scope','$stateParams',"requestHandler",'utils.constant','md5','ModalWindow','alertControl','$state'];
    function RechargeRecordController($scope,$stateParams,requestHandler,constant,md5,ModalWindow,alertControl,$state){
        let vm=this;
        let collect={
            'recordNum' : 0,
            'rechargeRecordList' : null,
            'getRechargeRecord' :getRechargeRecord,
            'freshRechargeRecord': freshRechargeRecord,
            'checkRechargeTransid' : checkRechargeTransid,
            'itemHeightlight' :itemHeightlight,   //高亮

        };
        vm.collect=collect;
        active();



        function active() {
            console.log('用户', $stateParams.userId);
            getRechargeRecord();
        }

        //获取充值记录
        function getRechargeRecord(){
            $('.bg').css('display','inline-block');
            console.log('获取充值记录');
            let _data = [{
                userid : $stateParams.userId
            }];
            let paramsStr = "rechargeInfo=" + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.getRechargeRecord, paramsStr,
                function(responce){
                    if (responce.data[0].result ==1){
                        $('.bg').css('display','none');
                        collect.rechargeRecordList = responce.data[0].responce;
                        collect.recordNum = responce.data[0].responce.length;
                    }else{
                        $('.bg').css('display','none');
                    }
                },
                function(){
                    $('.bg').css('display','none');
                }
            )
        }

        function freshRechargeRecord(){
            // $('.bg').css('display','inline-block');
            getRechargeRecord();
            // $('.bg').css('display','none');
        }

        function checkRechargeTransid(){
            $scope.userId=$stateParams.userId;
            ModalWindow.open({
                'templateUrl':'app/views/modals/checkRechargeTransidModal.html',
                'controller':'CheckRechargeTransidModalController',
                // 'width':320,
                // 'height':360,
                'scope':$scope,
                'windowClass':"qruser_window"
            });
        }

        function itemHeightlight(item,$index,event){
            console.log('item',item);
            console.log('$index',$index);
            console.log('event',event);
            $('.record_item').removeClass('heightLight');
            $('.record_item').eq($index).addClass('heightLight');
        }

    }
}

